export default {
  path: '/park/superviseBill',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'management',
      name: 'management',
      component: () => import('@/pages/supervisionBill/supervisionBillList/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管单单据列表',
      },
    },
    {
      path: 'edit',
      name: 'edit',
      component: () => import('@/pages/supervisionBill/supervisionBillDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管单维护',
      },
    },
    {
      path: 'supervisionBillDetail',
      name: 'supervisionBillDetail',
      component: () => import('@/pages/supervisionBill/supervisionBillDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管单详情',
      },
    },
    {
      path: 'billApproval',
      name: 'billApproval',
      component: () => import('@/pages/supervisionBill/supervisionBillDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管单审批',
      },
    },
    {
      path: 'stockInquiry',
      name: 'stockInquiry',
      component: () => import('@/pages/supervisionBill/supervisionBillStockInquiry/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管单库存查询',
      },
    },
    {
      path: 'outStockInquiry',
      name: 'outStockInquiry',
      component: () => import('@/pages/supervisionBill/supervisionBillStockInquiry/index.vue'),
      meta: {
        keepAlive: true,
        title: '外部账号库存查询',
      },
    },
  ],
};
